import { Set } from 'api/models/Sets';

export const getSetDisplayLabel = (set?: Set): string =>
  !set ? '' : set.sadlSetName || set.sadlSetDisplayCode || set.displayCode || '';

const useSetDisplayLabel = (set?: Set): string => getSetDisplayLabel(set);

export default useSetDisplayLabel;
